import React from 'react';
import ModalBT from 'react-bootstrap/Modal';
import styles from './ClearFieldModal.module.css';
import {FormActionButton} from "../../shared/buttons/FormActionButton";

interface ClearFieldModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    fieldLabel: string;
}

export const ClearFieldModal: React.FC<ClearFieldModalProps> = ({
    show,
    onClose,
    onConfirm,
    fieldLabel
}) => {
    return (
        <ModalBT
            show={show}
            onHide={onClose}
            aria-labelledby="clear-field-modal"
            centered
            dialogClassName={styles.modalDialog}
            contentClassName={styles.modalContent}
        >
            <ModalBT.Header closeButton className={styles.modalHeader}>
                <ModalBT.Title id="clear-field-modal">Подтверждение очистки</ModalBT.Title>
            </ModalBT.Header>

            <ModalBT.Body className={styles.modalBody}>
                <p className={styles.modalText}>
                    Вы уверены, что хотите очистить поле <strong>"{fieldLabel}"</strong>?
                </p>
            </ModalBT.Body>

            <div className={`d-flex gap-3 ${styles.buttonsWrapper}`}>
                <FormActionButton
                    mode="success"
                    text="Отмена"
                    onClick={onClose}
                    type="button"
                />
                <FormActionButton
                    mode="danger"
                    text="Очистить"
                    onClick={onConfirm}
                    type="button"
                />
            </div>
        </ModalBT>
    );
};
